import React from 'react';

const Cub = ({ width, height, color }) => (
  <div className="cub">
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={width} height={height} viewBox="0 0 86 85">
      <g>
        <g transform="translate(-186 -3130)">
          <path
            fill={color}
            d="M271.17 3197.4v16.8h-17v-16.8zm0-33.6v16.8h-17v-16.8zm0-33.6v16.8h-17v-16.8zm-34 67.2v16.8h-17v-16.8zm0-33.6v16.8h-17v-16.8zm0-33.6v16.8h-17v-16.8zm-34 67.2v16.8h-17v-16.8zm0-33.6v16.8h-17v-16.8zm0-33.6v16.8h-17v-16.8z"
          />
        </g>
      </g>
    </svg>
  </div>
);

export default Cub;
